import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-contact-hero-section',
  imports: [],
  templateUrl: './contact-hero-section.component.html',
  styleUrl: './contact-hero-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactHeroSectionComponent {}
